/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PalAuthSubmissionMetadata
 */
export interface PalAuthSubmissionMetadata {
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionMetadata
     */
    remote_dashboard_id?: string;
}

/**
 * Check if a given object implements the PalAuthSubmissionMetadata interface.
 */
export function instanceOfPalAuthSubmissionMetadata(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PalAuthSubmissionMetadataFromJSON(json: any): PalAuthSubmissionMetadata {
    return PalAuthSubmissionMetadataFromJSONTyped(json, false);
}

export function PalAuthSubmissionMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthSubmissionMetadata {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'remote_dashboard_id': !exists(json, 'remote_dashboard_id') ? undefined : json['remote_dashboard_id'],
    };
}

export function PalAuthSubmissionMetadataToJSON(value?: PalAuthSubmissionMetadata | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'remote_dashboard_id': value.remote_dashboard_id,
    };
}

